module.exports = __webpack_public_path__ + "img/Blog Admin 3.1b46eb24.jpg";